import styled from 'react-emotion'
import { container } from './platformLinkStyles'

const Container = styled.div`
  position: relative;

  ${container};
`

export default Container



// WEBPACK FOOTER //
// ./src/routes/home/components/Container.js